var map = {
	"./arabic.json": 858,
	"./bulgarian.json": 859,
	"./czech.json": 860,
	"./denmark.json": 861,
	"./english.json": 862,
	"./finnish.json": 863,
	"./greek.json": 864,
	"./indonesian.json": 865,
	"./malay.json": 866,
	"./norwegian.json": 867,
	"./romanian.json": 868,
	"./slovakia.json": 869,
	"./swedish.json": 870,
	"./thai.json": 871
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2480;


//////////////////
// WEBPACK FOOTER
// ./src/locales/playmix [A-Za-z0-9-_,\s]+\.json$/
// module id = 2480
// module chunks = 0